import { connect } from 'react-redux';

import { actions } from 'modules/account/notes';

import AccountNotes from './AccountNotes';

const mapDispatch = { fetchNotes: actions.fetchNotes };

export default connect(null, mapDispatch)(AccountNotes);
